import { MutationTree } from 'vuex';
import { State } from './pages.store';

const mutations: MutationTree<State> = {
  setPagesMetaData(state: State, [data, total]: any) {
    state.pagesMetaData = data;
    state.pagesMetaDataTotal = total;
  }
};

export default mutations;
